import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  padding: 8rem 0rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;
